module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "min-height",
      rawName: "v-min-height"
    }],
    staticClass: "fixed"
  }, [_c('c-view', [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "active-payment"
  }, [_c('div', {
    staticClass: "header bg-img"
  }, [_c('div', {
    staticClass: "header-desc"
  }, [_c('img', {
    staticClass: "alpha-logo",
    attrs: {
      "src": require("../../assets/images/logo/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-desc"
  }, [_vm._v("请绑定已开通扫码收款的店铺")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "register-form"
  }, [_c('div', {
    staticClass: "s-form-group bind-telephone"
  }, [_c('i', {
    staticClass: "s-icon s-icon-telephone prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.telephoneNum),
      expression: "formItem.telephoneNum"
    }],
    staticClass: "prepend-icon",
    attrs: {
      "type": "tel",
      "maxlength": "11",
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.formItem.telephoneNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formItem.telephoneNum = $event.target.value
      }, function($event) {
        _vm.validPhone = false
      }],
      "blur": function($event) {
        _vm.validatePhone()
      }
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validPhone),
      expression: "validPhone"
    }],
    staticClass: "s-icon s-icon-check-circle-italic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "s-form-group valid-code"
  }, [_c('i', {
    staticClass: "s-icon s-icon-password prepend-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.verifyCodeNum),
      expression: "formItem.verifyCodeNum"
    }],
    staticClass: "prepend-icon",
    attrs: {
      "type": "tel",
      "placeholder": "请输入验证码",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.formItem.verifyCodeNum)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.formItem.verifyCodeNum = $event.target.value
      }, function($event) {
        _vm.validPass = false
      }]
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validPass),
      expression: "validPass"
    }],
    staticClass: "s-icon s-icon-check-circle-italic"
  }), _vm._v(" "), _c('button', {
    staticClass: "input-button",
    class: [!_vm.validPhone ? 'disabled' : ''],
    attrs: {
      "disabled": !_vm.validPhone
    },
    on: {
      "click": function($event) {
        _vm.getCode()
      }
    }
  }, [(_vm.formItem.codeWorking) ? _c('span', {
    staticClass: "text-color gray"
  }, [_vm._v(" " + _vm._s(_vm.formItem.timeSecond))]) : _c('span', [_vm._v("发送验证码")])])])]), _vm._v(" "), (_vm.storeName) ? _c('div', {
    staticClass: "shop-name"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.storeName) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "s-btn s-btn--orange",
    on: {
      "click": function($event) {
        _vm.nextStep()
      }
    }
  }, [_vm._v("立即激活")]), _vm._v(" "), _c('div', {
    staticClass: "text-center use-info"
  }, [_c('span', {
    on: {
      "click": function($event) {
        _vm.toggleDialog()
      }
    }
  }, [_vm._v("使用说明")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-container"
  }, [_c('info-footer')], 1)])]), _vm._v(" "), (_vm.showDialog) ? _c('c-dialog', [_c('div', {
    slot: "bd-content"
  }, [_c('div', {
    staticClass: "scroll-content"
  }, [_c('img', {
    staticClass: "info-img",
    attrs: {
      "src": require("../../assets/images/active-payment/info.png"),
      "alt": "使用说明"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "text-color orange closeDialog",
    on: {
      "click": _vm.toggleDialog
    }
  }, [_vm._v("我知道了")])])]) : _vm._e(), _vm._v(" "), (_vm.ifShowDialog) ? _c('div', {
    staticClass: "s-dialog-mask"
  }, [_c('div', {
    staticClass: "s-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "s-dialog-box"
  }, [_c('div', {
    staticClass: "s-dialog-content"
  }, [_c('div', {
    staticClass: "close-box"
  }, [_c('img', {
    attrs: {
      "src": "http://static.i200.cn/benjamin/mainWeb/FvmMxgTagfifVZRDXnMuy_VyUYZb.png"
    },
    on: {
      "click": _vm.closeDialog
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    staticClass: "info-img",
    attrs: {
      "src": _vm.dialogDetail.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-content"
  }, [_c('div', [_c('p', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.dialogDetail.title))]), _vm._v(" "), _c('p', {
    staticClass: "content-detail"
  }, [_vm._v("下载生意专家手机APP进行注册可实时")]), _vm._v(" "), _c('p', {
    staticClass: "content-detail"
  }, [_vm._v("接收收款通知")])]), _vm._v(" "), _c('button', {
    staticClass: "bind-account",
    on: {
      "click": _vm.clearPhone
    }
  }, [_vm._v("绑定其他账号")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=com.ShengYiZhuanJia.five"
    }
  }, [_c('button', {
    staticClass: "download-app"
  }, [_vm._v("下载APP")])])])])])]) : _vm._e()], 1), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22233834","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/active-payment/index.vue
// module id = 356
// module chunks = 0